var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-panel" }, [
    _c("div", { staticClass: "left-wrapper" }, [
      _c(
        "div",
        { staticClass: "card-panel-icon-wrapper icon-money" },
        [_c("font-awesome-icon", { attrs: { icon: "building", size: "3x" } })],
        1
      ),
    ]),
    _c("div", { staticClass: "card-panel-description" }, [
      _c("div", { staticClass: "card-panel-text" }, [_vm._v("Common")]),
      _c(
        "div",
        { staticClass: "card-detail" },
        [
          _c("span", [_vm._v("Total Product:")]),
          _c("count-to", {
            staticClass: "card-panel-num primary-color",
            attrs: {
              "start-val": 0,
              "end-val": _vm.summary.totalProduct,
              duration: 3200,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "card-detail" },
        [
          _c("span", [_vm._v("Total Category:")]),
          _c("count-to", {
            staticClass: "card-panel-num error-color",
            attrs: {
              "start-val": 0,
              "end-val": _vm.summary.totalCategory,
              duration: 3200,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "card-detail" },
        [
          _c("span", [_vm._v("Total Staff:")]),
          _c("count-to", {
            staticClass: "card-panel-num yellow-color",
            attrs: {
              "start-val": 0,
              "end-val": _vm.summary.totalStaff,
              duration: 3200,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }